export const popularGuides = [
  {
    title: "Gold Look-Alikes",
    description: "Compare pyrite, chalcopyrite, mica, and native gold using streak, deformation, hardness, tarnish, and density.",
    href: "/identify/gold-lookalikes",
    type: "Field guide",
  },
  {
    title: "Quartz vs Calcite",
    description: "Compare hardness, cleavage, fracture, and dilute-acid response with a safe workflow.",
    href: "/compare/quartz-vs-calcite",
    type: "Comparison",
  },
  {
    title: "Magnetite vs Hematite",
    description: "Check magnetism, streak, colour, and crystal habit to tell these iron oxides apart.",
    href: "/compare/magnetite-vs-hematite",
    type: "Comparison",
  },
  {
    title: "Black Metallic Minerals",
    description: "Narrow common dark metallic minerals using magnetism, streak, heft, and cleavage.",
    href: "/identify/black-metallic-minerals",
    type: "Field guide",
  },
  {
    title: "Meteorite vs Slag",
    description: "Screen magnetic, heavy, or crusted finds using bubbles, streak, fusion crust, context, and confirmation limits.",
    href: "/compare/meteorite-vs-slag",
    type: "Comparison",
  },
  {
    title: "Minerals That Scratch Glass",
    description: "Understand the glass test, likely candidates, and the difference between a mark and a scratch.",
    href: "/identify/minerals-that-scratch-glass",
    type: "Field guide",
  },
] as const;
